<template>
  <el-dialog
      ref="mslQRCodeDialog"
      width="350px"
      :visible.sync="dialogVisible"
      :scrollbar="false"
      :modal="false"
      :append-to-body="true"
      custom-class="msl-qrcode-dialog"
      @close="onClose"
      @closed="onClosed"
      @open="onOpen"
      @opened="onOpened"
  >
    <div class="qrcode">
      <h3 style="text-align: center">Open WeChat to scan the qrcode <br>and bind with the account</h3>
      <el-image :src="qrcodeUrl" v-loading="loading" @load="imageLoad">
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
      <p>{{ userInfo.name }}</p>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "QRCodeDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      loading: true,
      qrcodeUrl: "",
      timer: null
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo || {};
    },
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
  },
  methods: {
    onClosed() {
      this.qrcodeUrl = "";
      this.$emit("update:visible", false);
      this.clearTimer();
    },
    imageLoad() {
      this.loading = false;
    },
    onOpened() {
      const mslQRCodeDialog = this.$refs.mslQRCodeDialog.$el;
      mslQRCodeDialog.style.transition = "background-color 0.05s";
      mslQRCodeDialog.style.zIndex = "2003";
      mslQRCodeDialog.style.backgroundColor = "rgba(0,0,0,0.5)"
    },
    onClose() {
      const mslQRCodeDialog = this.$refs.mslQRCodeDialog.$el;
      mslQRCodeDialog.style.transition = "background-color 0.05s";
      mslQRCodeDialog.style.backgroundColor = "rgba(0,0,0,0)";
      this.checkBindWeChatStatus();
    },
    onOpen() {
      const mslQRCodeDialog = this.$refs.mslQRCodeDialog.$el;
      mslQRCodeDialog.style.transition = "background-color 0.05s";
      mslQRCodeDialog.style.zIndex = "2003";
      mslQRCodeDialog.style.backgroundColor = "rgba(0,0,0,0.5)";
      this.loading = true;
      this.axios
          .get("/user/qrCode")
          .then(({code, data}) => {
            if (code === 200) {
              this.qrcodeUrl = data;
              this.refreshStatus();
            } else {
              this.$message.error("Get QR Code failed");
            }
          });
    },
    refreshStatus() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      let i = 90;
      this.timer = setInterval(() => {
        i--;
        if (i === 0) {
          clearInterval(this.timer);
          this.timer = null;
        }
        this.checkBindWeChatStatus();
      }, 1000);
    },
    checkBindWeChatStatus() {
      this.axios.get("/user/bind", {
        headers: {
          showLoading: false
        }
      }).then(({code, data}) => {
        if (code === 200 && data) {
          const bindStatus = data.bindStatus;
          if (bindStatus === 2) {
            this.$store.commit("updateState", {
              userInfo: {
                ...this.userInfo,
                bindStatus
              }
            });
            this.dialogVisible = false;
            this.clearTimer();
          }
        } else {
          this.clearTimer();
        }
      }).catch(() => {
        this.clearTimer();
      })
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  },
};
</script>

<style lang="scss" scoped>

::v-deep {
  .el-dialog__header {
    height: 45px;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog__footer {
    text-align: right;
    padding: 0 20px 20px;
  }
}

.qrcode {
  position: relative;
  padding: 30px;

  h3 {
    color: #000;
  }

  .el-image {
    margin: 20px 0;
    width: 200px;
    height: 200px;
  }

  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    font-weight: bold;
    color: #000;
  }
}
</style>
